module.exports = __webpack_public_path__ + "static/media/saga_loading.6c413f2f.png";